import {
  BaSeHeading6,
  BaSeIcon,
  BaSeParagraph,
  BaSeTheme,
  BaSeTooltip,
} from '@base/react';
import React from 'react';
import { InfoBody, InfoHeader } from './selection-interview-styled';

export const MicrophoneInformation = ({ inDesktop, answer, showTooltip }) => {
  const [openTooltip, setOpenTooltip] = React.useState(showTooltip);

  const infoMessage = [
    <InfoHeader key="header">
      <BaSeIcon
        name="lightbulb-alt"
        size="16"
        description="icon-lightulb-als"
        color={BaSeTheme.colors.institucionais.cinzaSebrae30}
      />
      <BaSeHeading6
        isBold
        color={BaSeTheme.colors.institucionais.cinzaSebrae30}
      >
        Grave que convertemos em texto
      </BaSeHeading6>
      <BaSeIcon
        name="times"
        size="16"
        description="icon-times"
        onClick={() => setOpenTooltip(false)}
        color={BaSeTheme.colors.institucionais.cinzaSebrae30}
      />
    </InfoHeader>,
    <InfoBody key="body">
      {inDesktop ? (
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae30}>
          Para te ajudar, você tem a opção de responder por áudio e tudo será
          convertido em texto
        </BaSeParagraph>
      ) : (
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae30}>
          Para te ajudar, você tem a opção de responder por áudio, utilizando o
          recurso nativo do seu teclado e tudo será convertido em texto
        </BaSeParagraph>
      )}
      <BaSeHeading6
        isBold
        color={BaSeTheme.colors.institucionais.cinzaSebrae30}
      >
        Fique atento
      </BaSeHeading6>
      <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae30}>
        Nem sempre a conversão fica 100%, então faça uma revisão e altere o
        texto que precisar ;)
      </BaSeParagraph>
    </InfoBody>,
  ];

  return (
    <BaSeTooltip
      color={BaSeTheme.colors.institucionais.cinzaSebrae30}
      delayToOpen={0}
      direction={inDesktop ? 'left' : 'neutral'}
      message={infoMessage}
      coordinates={
        inDesktop
          ? { right: '45px', top: '-55px' }
          : { left: '10px', top: '15px' }
      }
      open={openTooltip}
      size="medium"
      themeMode="light"
      width={inDesktop ? 275 : 220}
    />
  );
};
